<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Customer-Manage",
  path: "manage",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
